
export class KioskSettingNames {
    public static BoatLaunchTicketTemplate = "BoatLaunchTicketTemplate";
    public static BusDayUseTicketTemplate = "BusDayUseTicketTemplate";
    public static CampsiteTicketTemplate = "CampsiteTicketTemplate";
    public static CarAnnualTicketTemplate = "CarAnnualTicketTemplate";
    public static CarDayUseTicketTemplate = "CarDayUseTicketTemplate";
    public static DayPassTicketTemplate = "DayPassTicketTemplate";
    public static DaysSinceLastSyncThreshold = "DaysSinceLastSyncThreshold";
    public static DefaultTicketStockAmount = "DefaultTicketStockAmount";
    public static DonationTicketTemplate = "DonationTicketTemplate";
    public static ExtraTentsTicketTemplate = "ExtraTentsTicketTemplate";
    public static ExtraVehiclesTicketTemplate = "ExtraVehiclesTicketTemplate";
    public static FirewoodTicketTemplate = "FirewoodTicketTemplate";
    public static GroupShelterTicketTemplate = "GroupShelterTicketTemplate";
    public static HikerBikerTicketTemplate = "HikerBikerTicketTemplate";
    public static LowBatteryVoltageThreshold = "LowBatteryVoltageThreshold";
    public static LowestMeasuredBatteryVoltage = "LowestMeasuredBatteryVoltage";
    public static LowTicketStockThreshold = "LowTicketStockThreshold";
    public static PassCode = "PassCode";
    public static PaymentProcessor = "PaymentProcessor";
    public static ResetTicketStockAmount = "ResetTicketStockAmount";
    public static SendDeclinedBatchTransactionEmail = "SendDeclinedBatchTransactionEmail";
    public static SendDelayedKioskCloudSyncEmail = "SendDelayedKioskCloudSyncEmail";
    public static SendHealthEmail = "SendHealthEmail";
    public static SendLowBatteryVoltageEmail = "SendLowBatteryVoltageEmail";
    public static SendLowTicketStockEmail = "SendLowTicketStockEmail";
    public static ShelterTicketTemplate = "ShelterTicketTemplate";
    public static TicketTemplate = "TicketTemplate";
    public static TransactionAmount = "TransactionAmount";
    public static UploadLogFiles = "UploadLogFiles";
    public static VanDayUseTicketTemplate = "VanDayUseTicketTemplate";
    public static Workflow = "Workflow";
}